import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import Button from 'src/ui/library/Button';
import serviceUrls from 'src/constants/serviceUrls';
import { enablePresist } from 'src/helpers';

class SSOLogin extends Component {
  state = {
    ssologinEnable: false,
  };

  componentDidMount() {
    let queryParams = this.props.location.search;
    const params = new URLSearchParams(queryParams);
    if (queryParams.includes('sTok') && params.get('sTok')) {
      return this.props.onClick(params.get('sTok'));
    }
  }

  onLoginClick = evt => {
    enablePresist();
    evt.preventDefault();
    this.setState({ ssologinEnable: true });
    window.location.assign(`${serviceUrls.SSO_URLS}`);
  };

  render() {
    const { loginStatus, isUserLocked } = this.props;
    return (
      <Fragment>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <p className="bodyContent">Please click the 'Log in' button to login using SSO</p>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Button
            onClick={this.onLoginClick}
            styleType={'login'}
            disabled={this.state.ssologinEnable || isUserLocked || loginStatus === 'PENDING'}>
            <span>{intl.get('login.loginbutton')}</span>
          </Button>
        </Grid>
      </Fragment>
    );
  }
}

export default SSOLogin;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/SSOLoginPres.js